
<style scoped>
.wrap {
  display: flex;
  flex-wrap: wrap;
  margin-left: 10px;
}
.card {
  width: 25%;
  height: 400px;
  margin: 16px 0 0 0;
  border-right: 15px solid#E9EEF3;
  box-sizing: border-box;
  position: relative;
  background: #fff;
  text-align: left;
}
.card img {
  width: 100%;
  height: 180px;
}
.card .title {
  margin-top: 20px;
  margin-left: 16px;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
}
.card .desc {
  padding: 0 16px;
}
.btn {
  height: 40px;
  background: #4fa1a4;
  color: #fff;
  line-height: 40px;
  text-align: center;
  width: 90%;
  position: absolute;
  left: 5%;
  bottom: 10px;
}
.search-area {
  display: flex;
  margin: 0 15px 0 10px;
  text-align: left;
  font-weight: bold;
  align-items: center;
}

.label {
  height: 40px;
  background: #deefeb;
  width: 100%;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
}
.label span {
  text-decoration: underline;
  margin-left: 20px;
  cursor: pointer;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area" v-if="listType == 2 && onlineDetail.meetingPlatformName">
      <div class="label">
        当前使用【{{ onlineDetail.meetingPlatformName }}】预定,<span @click="joinMeeting">点击参与会议</span>
      </div>
    </div>
    <div class="wrap">
      <div class="card" v-for="(item, index) in platformList" :key="index">
        <img :src="item.backgroundImageUrl" alt="" srcset="" />
        <div class="title">{{ item.platformName }}</div>
        <div class="desc">{{ item.note }}</div>
        <div class="btn" @click="toPlatorm(item)">进入</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fullscreenLoading: false,
      platformList: [],
      listType: null,
      onlineDetail: null,
    };
  },
  created() {
    // 列表
    this.getPlatform();

    this.listType = this.$route.query.listType;
  },
  methods: {
    getPlatform() {
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: -1,
        isOpen: '1',
        platformUse:-1,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/platform/get-list`, page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.platformList = res.data.data.records;
          this.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getData() {
      let self = this;
      self.api
        .postCan(
          `/${serverConfig.msSalesPerformService}/flow/data/get-online-meeting-detail?guid=` + self.$route.query.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.onlineDetail = res.data.data;
            self.platformList.forEach((item) => {
              if (self.onlineDetail.meetingPlatformGuid == item.guid) {
                self.onlineDetail.meetingPlatformName = item.platformName;
              }
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    joinMeeting() {
      var url = this.onlineDetail.meetingUrl || this.onlineDetail.videoUrl;
      if (url) {
        window.open(url);
      } else {
        this.$message({
          message: '暂无链接！',
          type: 'error',
        });
      }
    },
    toPlatorm(item) {
      if (item.platformUrl) {
        window.open(item.platformUrl);
      } else {
        this.$message({
          message: '暂无链接！',
          type: 'error',
        });
      }
    },
  },
};
</script> 
